module.exports = __webpack_public_path__ + "static/img/6.0b357cae.png";